import { render, staticRenderFns } from "./OverviewRS.vue?vue&type=template&id=6b3d7278&scoped=true&"
import script from "./OverviewRS.vue?vue&type=script&lang=js&"
export * from "./OverviewRS.vue?vue&type=script&lang=js&"
import style0 from "./OverviewRS.vue?vue&type=style&index=0&id=6b3d7278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d7278",
  null
  
)

export default component.exports